import Icon from '@ant-design/icons';

/** Символ рубля без круга — для меню тарифов. */
const RubleSvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" focusable="false">
    <text
      x="512"
      y="720"
      textAnchor="middle"
      fontSize="780"
      fontFamily="Arial, Helvetica, sans-serif"
      fontWeight="600"
      fill="currentColor"
    >
      ₽
    </text>
  </svg>
);

export default function RubleCircleOutlined(props) {
  return <Icon component={RubleSvg} {...props} />;
}
